import type { UseQueryOptions } from "react-query";
import { useQuery } from "react-query";
import { internalApi } from "@/react/helpers/urlHelpers";
import type { MemberTag } from "@/react/types";
import { reactQueryGet } from "@circle-react/helpers/backendRequestHelpers";

type QueryKeyType = readonly ["member-tag", string];

export const useFetchMemberTag = ({
  id,
  options = {},
}: {
  id: number;
  options?: Omit<
    UseQueryOptions<MemberTag, unknown, MemberTag, QueryKeyType>,
    "queryKey" | "queryFn"
  >;
}) =>
  useQuery(
    ["member-tag", id.toString()] as const,
    () => reactQueryGet<MemberTag>(internalApi.memberTags.show({ id })),
    {
      enabled: !!id,
      ...options,
    },
  );
